import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import Navbar from '../../Pages/Navbar/EmployerNavbar';
import Footer from "../../Footer/Footer"
import Swal from 'sweetalert2';
import BaseUrl from '../../ApiServices/BaseUrl';
import './JobDetails.css';

function JobDetails() {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { jobId, id } = useParams();
    const effectiveJobId = jobId || id;
    const user = JSON.parse(localStorage.getItem('user')) || {};
    const userId = user?.id;

    const safeParseArray = (value) => {
        try {
            if (!value) return [];
            if (Array.isArray(value)) return value;
            return JSON.parse(value);
        } catch (e) {
            return [];
        }
    };

    // Parse the initial job from router state once at mount time
    const [job, setJob] = useState(() => {
        const initialJob = state?.job || null;
        if (!initialJob) return null;
        return {
            ...initialJob,
            preferred_years_of_experience: safeParseArray(initialJob.preferred_years_of_experience),
            candidates_country_experience: safeParseArray(initialJob.candidates_country_experience),
            preferred_candidates_country: safeParseArray(initialJob.preferred_candidates_country),
            preferred_language_for_worker: safeParseArray(initialJob.preferred_language_for_worker),
            main_skills: safeParseArray(initialJob.main_skills),
            cooking_skills: safeParseArray(initialJob.cooking_skills),
            other_skills: safeParseArray(initialJob.other_skills),
            offer_for_selected_candidates: safeParseArray(initialJob.offer_for_selected_candidates),
            profile_photo_url: initialJob.profile_photo ? `${BaseUrl}${initialJob.profile_photo}` : null
        };
    });
    const [applied, setApplied] = useState(false);
    const [loading, setLoading] = useState(true);
    const [showRegisterPopup, setShowRegisterPopup] = useState(false);
    const [showLoginPopup, setShowLoginPopup] = useState(false);
    const [hasResume, setHasResume] = useState(false);
    const [relatedJobs, setRelatedJobs] = useState([]);



    const JOB_REQUIREMENT_ICONS = {
        jobRole: 'user',
        jobType: 'briefcase',
        startDate: 'calendar',
        location: 'map-pin',
        contract: 'file-text',
        accommodation: 'home',
        dayOff: 'calendar'
    };




    const RequirementItem = ({ iconKey, label, value }) => (
        <div className="jr-card">
            <div className="jr-icon">
                {/* Job Requirement Icons */}
                {iconKey === 'jobRole' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                )}
                {iconKey === 'jobType' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                    </svg>
                )}
                {iconKey === 'startDate' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                )}
                {iconKey === 'location' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                )}
                {iconKey === 'contract' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                        <polyline points="10 9 9 9 8 9"></polyline>
                    </svg>
                )}
                {iconKey === 'accommodation' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                    </svg>
                )}
                {iconKey === 'dayOff' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                )}

                {/* Candidate Requirements Icons */}
                {iconKey === 'gender' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="8" r="5"></circle>
                        <path d="M3 21v-4a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v4"></path>
                    </svg>
                )}
                {iconKey === 'religion' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="8" x2="12" y2="12"></line>
                        <line x1="12" y1="16" x2="12" y2="16"></line>
                    </svg>
                )}
                {iconKey === 'education' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
                        <path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5"></path>
                    </svg>
                )}
                {iconKey === 'age' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                )}
                {iconKey === 'experience' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                )}
                {iconKey === 'years-experience' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                    </svg>
                )}
                {iconKey === 'globe' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="2" y1="12" x2="22" y2="12"></line>
                        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                    </svg>
                )}
                {iconKey === 'country-experience' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                )}
                {iconKey === 'gulf-experience' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 8h1a4 4 0 0 1 0 8h-1"></path>
                        <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path>
                        <line x1="6" y1="1" x2="6" y2="4"></line>
                        <line x1="10" y1="1" x2="10" y2="4"></line>
                        <line x1="14" y1="1" x2="14" y2="4"></line>
                    </svg>
                )}
                {iconKey === 'total-experience' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                )}

                {/* Skills Icons */}
                {iconKey === 'star' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                    </svg>
                )}
                {iconKey === 'language' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                )}
                {iconKey === 'main-skills' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                        <path d="M2 17l10 5 10-5"></path>
                        <path d="M2 12l10 5 10-5"></path>
                    </svg>
                )}
                {iconKey === 'cooking' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M18 8h1a4 4 0 0 1 0 8h-1"></path>
                        <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path>
                        <line x1="6" y1="1" x2="6" y2="4"></line>
                        <line x1="10" y1="1" x2="10" y2="4"></line>
                        <line x1="14" y1="1" x2="14" y2="4"></line>
                    </svg>
                )}
                {iconKey === 'other-skills' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                        <path d="M2 17l10 5 10-5"></path>
                        <path d="M2 12l10 5 10-5"></path>
                    </svg>
                )}

                {iconKey === 'salary' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="12" y1="1" x2="12" y2="23"></line>
                        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                    </svg>
                )}
                {iconKey === 'benefits' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                    </svg>
                )}
                {iconKey === 'family' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                        <circle cx="9" cy="7" r="4"></circle>
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                )}
                {iconKey === 'house' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                    </svg>
                )}
                {iconKey === 'pets' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="4.5" cy="9.5" r="2.5"></circle>
                        <circle cx="9" cy="5.5" r="2.5"></circle>
                        <circle cx="15" cy="5.5" r="2.5"></circle>
                        <circle cx="19.5" cy="9.5" r="2.5"></circle>
                        <path d="M17.5 19.5c-2.5 2.5-6.5 2.5-9 0"></path>
                    </svg>
                )}
                {iconKey === 'current-helper' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                )}
                {iconKey === 'helper-name' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                        <line x1="12" y1="13" x2="12" y2="13"></line>
                    </svg>
                )}
                {iconKey === 'helper-nationality' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="2" y1="12" x2="22" y2="12"></line>
                        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                    </svg>
                )}
                {iconKey === 'user' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                )}
                {iconKey === 'organization' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                    </svg>
                )}
                {iconKey === 'email' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                        <polyline points="22,6 12,13 2,6"></polyline>
                    </svg>
                )}
                {iconKey === 'phone' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                )}
                {iconKey === 'whatsapp' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
                    </svg>
                )}
                {iconKey === 'location-preference' && (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                )}
            </div>
            <div className="jr-content">
                <span className="jr-label">{label}</span>
                <span className="jr-value">{value}</span>
            </div>
        </div>
    );

    const recordProfileView = async (targetId, targetType, viewType, itemId = null) => {
        try {
            if (!user.id || user.id === targetId) return;
            await fetch(`${BaseUrl}/api/profile-viewers/record`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    target_user_id: targetId,
                    target_user_type: targetType,
                    viewer_user_id: user.id,
                    viewer_name: user.name || user.first_name || 'Anonymous',
                    viewer_email: user.email || user.email_id || '',
                    viewer_phone: user.mobile_number || user.phone || user.mobile || '',
                    viewer_user_type: user.role,
                    view_type: viewType,
                    viewed_item_id: itemId
                })
            });
        } catch (err) {
            console.error('Error recording view:', err);
        }
    };

    useEffect(() => {
        const fetchJobDetails = async () => {
            try {
                // If job not passed via state, fetch it by ID
                if (!job && effectiveJobId) {
                    let response = await fetch(`${BaseUrl}/api/employer/${effectiveJobId}`);

                    if (!response.ok && response.status === 404) {
                        const fallbackUrl = `${BaseUrl}/api/employer?temporary_id=${effectiveJobId}&user_id=${userId || ''}`;
                        response = await fetch(fallbackUrl);
                    }

                    // Third fallback: fetch by user_id alone
                    if (!response.ok && response.status === 404 && userId) {
                        response = await fetch(`${BaseUrl}/api/employer/user/${userId}`);
                    }

                    if (!response.ok) {
                        throw new Error('Failed to fetch job details');
                    }
                    const data = await response.json();

                    // Safely parse all array fields in the job data
                    const parsedJob = {
                        ...data,
                        preferred_years_of_experience: safeParseArray(data.preferred_years_of_experience),
                        candidates_country_experience: safeParseArray(data.candidates_country_experience),
                        preferred_candidates_country: safeParseArray(data.preferred_candidates_country),
                        preferred_language_for_worker: safeParseArray(data.preferred_language_for_worker),
                        main_skills: safeParseArray(data.main_skills),
                        cooking_skills: safeParseArray(data.cooking_skills),
                        other_skills: safeParseArray(data.other_skills),
                        offer_for_selected_candidates: safeParseArray(data.offer_for_selected_candidates),
                        profile_photo_url: data.profile_photo ? `${BaseUrl}${data.profile_photo}` : null
                    };

                    setJob(parsedJob);
                    if (parsedJob.user_id) recordProfileView(parsedJob.user_id, parsedJob.employer_source || 'employer', 'job', parsedJob.id);
                }
                // Job already parsed via useState initializer — no need to re-parse

                // Check if user has applied and has resume
                if (userId) {
                    // Check application status
                    const applicationResponse = await fetch(`${BaseUrl}/api/applications?userid=${userId}&jobid=${effectiveJobId || job?.id}`);
                    const applicationData = await applicationResponse.json();
                    if (applicationResponse.ok && applicationData.length > 0) {
                        setApplied(true);
                    }

                    // Check resume status
                    const resumeResponse = await fetch(`${BaseUrl}/api/job-seeker?user_id=${userId}`);
                    const resumeData = await resumeResponse.json();
                    setHasResume(resumeData.length > 0);
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchJobDetails();
    }, [effectiveJobId, userId]);

    useEffect(() => {
        const fetchRelatedJobs = async () => {
            if (!job?.domestic_worker_category) return;

            try {
                const response = await fetch(`${BaseUrl}/api/employer/all`);
                if (!response.ok) {
                    throw new Error('Failed to fetch jobs');
                }
                let data = await response.json();

                // Filter jobs where status is 'Approved' and category matches
                data = data.filter(relatedJob =>
                    relatedJob.status === 'Approved' &&
                    relatedJob.domestic_worker_category === job.domestic_worker_category &&
                    relatedJob.id !== (effectiveJobId || job?.id) // Exclude current job
                ).slice(0, 4); // Limit to 4 jobs

                // Safely parse all relevant fields for related jobs
                data = data.map(relatedJob => ({
                    ...relatedJob,
                    preferred_candidates_country: safeParseArray(relatedJob.preferred_candidates_country),
                    candidates_country_experience: safeParseArray(relatedJob.candidates_country_experience),
                    main_skills: safeParseArray(relatedJob.main_skills),
                    cooking_skills: safeParseArray(relatedJob.cooking_skills),
                    other_skills: safeParseArray(relatedJob.other_skills),
                    preferred_years_of_experience: safeParseArray(relatedJob.preferred_years_of_experience),
                    offer_for_selected_candidates: safeParseArray(relatedJob.offer_for_selected_candidates),
                    preferred_language_for_worker: safeParseArray(relatedJob.preferred_language_for_worker),
                    profile_photo_url: relatedJob.profile_photo
                        ? `${BaseUrl}${relatedJob.profile_photo}`
                        : null
                }));

                setRelatedJobs(data);
            } catch (err) {
                console.error('Error fetching related jobs:', err);
            }
        };

        if (job?.domestic_worker_category) {
            fetchRelatedJobs();
        }
    }, [job?.domestic_worker_category, job?.id, effectiveJobId]);

    const showPhotoOnboardingPopup = () => {
        Swal.fire({
            title: 'Add Your Profile Photo',
            html: `<p style="color:#555;font-size:14px;line-height:1.6;">
                Profiles with photos get <strong style="color:#28a745;">3x more responses</strong> from candidates.
                Add a clear photo to stand out!
            </p>`,
            iconHtml: `<span style="font-size:38px;">📸</span>`,
            showCancelButton: false,
            showCloseButton: true,
            confirmButtonText: 'Upload Photo',
            confirmButtonColor: '#28a745',
            customClass: {
                icon: 'border-0'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                navigate('/addprofilephoto', {
                    state: {
                        userId: user.id,
                        temporaryId: job?.temporary_id || effectiveJobId,
                        fromRegistration: true,
                        showJobPopupAfter: true
                    }
                });
            } else {
                // Skip → show profile completion popup
                showJobOnboardingPopup();
            }
        });
    };

    const showJobOnboardingPopup = () => {
        Swal.fire({
            title: 'Complete Your Job Posting',
            html: `
                <p style="color:#555;font-size:14px;line-height:1.6;margin-bottom:10px;">
                    A complete job posting helps candidates find you faster. Fill in your requirements
                    to get noticed!
                </p>
                <div style="background:#fff3cd;border-radius:8px;padding:10px 14px;font-size:13px;color:#856404;margin-top:8px;">
                    ⚡ Complete postings are <strong>5x more likely</strong> to get right candidates
                </div>
            `,
            iconHtml: `<span style="font-size:38px;">✏️</span>`,
            showCancelButton: false,
            showCloseButton: true,
            showDenyButton: true,
            denyButtonText: 'View Job Detail',
            confirmButtonText: 'Complete Job Posting',
            confirmButtonColor: '#28a745',
            denyButtonColor: '#6c757d',
            customClass: {
                icon: 'border-0'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                navigate('/basicinfo');
            }
            // If denied (View Job Detail), popup just closes
        });
    };

    // Onboarding popup for first-time visit by employer after registration
    useEffect(() => {
        if (!userId || loading || !job) return;

        // Check if coming from registration directly
        if (localStorage.getItem('showEmployerWelcomePopup') === 'true') {
            localStorage.removeItem('showEmployerWelcomePopup');
            const timer = setTimeout(() => {
                showPhotoOnboardingPopup();
            }, 800);
            return () => clearTimeout(timer);
        }

        if (state?.showJobPopupAfter) {
            const timer = setTimeout(() => {
                // Clear the state by replacing the history entry
                const newState = { ...state };
                delete newState.showJobPopupAfter;
                navigate(window.location.pathname, { replace: true, state: newState });

                showJobOnboardingPopup();
            }, 600);
            return () => clearTimeout(timer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId, loading, job?.id]);

    const handleBackToList = () => {
        navigate('/viewjobposting');
    };

    // Helper function to strip HTML tags and display plain text
    const stripHTML = (html) => {
        if (!html) return 'No description available';

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || 'No description available';
    };

    const handleApply = async () => {
        if (!user.id) {
            Swal.fire({
                title: 'Registration Required',
                text: 'You need to register or login to apply for this job',
                icon: 'info',
                showCancelButton: true,
                confirmButtonText: 'Register',
                cancelButtonText: 'Login',
                customClass: {
                    popup: 'registration-popup'
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/register');
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    navigate('/login');
                }
            });
            return;
        }

        if (!hasResume) {
            Swal.fire({
                title: 'Resume Required',
                text: 'You need to update your resume before applying for jobs',
                icon: 'info',
                confirmButtonText: 'Update resume',
                confirmButtonColor: '#28a745'
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/personalinfo');
                }
            });
            return;
        }

        try {
            const payload = {
                userid: user.id,
                empuserid: job.user_id,
                jobid: job.id,
            };

            const response = await fetch(`${BaseUrl}/api/applications`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'You have successfully applied for this job',
                    confirmButtonColor: '#28a745'
                });
                setApplied(true);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: data.error || 'Failed to apply for job',
                    confirmButtonColor: '#d33'
                });
            }
        } catch (err) {
            console.error('Error while applying:', err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred while applying: ' + err.message,
                confirmButtonColor: '#d33'
            });
        }
    };

    const closeRegisterPopup = () => {
        setShowRegisterPopup(false);
    };

    const closeLoginPopup = () => {
        setShowLoginPopup(false);
    };

    const handleLoginSuccess = async () => {
        closeLoginPopup();
        const updatedUser = JSON.parse(localStorage.getItem('user')) || {};

        setLoading(true);
        try {
            if (updatedUser.id && job?.id) {
                const applicationResponse = await fetch(`${BaseUrl}/api/applications?userid=${updatedUser.id}&jobid=${job.id}`);
                const applicationData = await applicationResponse.json();
                if (applicationResponse.ok && applicationData.length > 0) {
                    setApplied(true);
                }

                const resumeResponse = await fetch(`${BaseUrl}/api/job-seeker?user_id=${updatedUser.id}`);
                const resumeData = await resumeResponse.json();
                setHasResume(resumeData.length > 0);
            }
        } catch (err) {
            console.error('Error checking application status:', err);
        } finally {
            setLoading(false);
        }
    };

    const safeJoin = (array, separator = ', ') => {
        if (!array) return 'N/A';
        return Array.isArray(array) ? array.join(separator) : array;
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            // Handle both date-only and datetime strings
            const date = new Date(dateString);
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        } catch (e) {
            console.error('Error formatting date:', e);
            return 'N/A';
        }
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return 'N/A';
        try {
            const date = new Date(dateString);
            return date.toLocaleString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        } catch (e) {
            console.error('Error formatting date time:', e);
            return 'N/A';
        }
    };

    // Helper to display salary information with both original currency and USD
    // Helper to display salary information with both original currency and USD
    const displaySalary = () => {
        if (!job.minimum_monthly_salary || job.minimum_monthly_salary === "0.00") {
            return 'Not specified';
        }

        const minSalary = parseFloat(job.minimum_monthly_salary);
        const maxSalary = parseFloat(job.maximum_monthly_salary);

        // Define conversion rates to USD (example rates - you can update these)
        const conversionRates = {
            'AED': 0.27,   // 1 AED = 0.27 USD
            'SAR': 0.27,   // 1 SAR = 0.27 USD
            'QAR': 0.27,   // 1 QAR = 0.27 USD
            'OMR': 2.60,   // 1 OMR = 2.60 USD
            'BHD': 2.65,   // 1 BHD = 2.65 USD
            'KWD': 3.25,   // 1 KWD = 3.25 USD
            'INR': 0.012,  // 1 INR = 0.012 USD
            'EUR': 1.08,   // 1 EUR = 1.08 USD
            'GBP': 1.27,   // 1 GBP = 1.27 USD
            'USD': 1.00    // 1 USD = 1.00 USD
        };

        // Get original currency from database
        let originalCurrency = job.country_currency || 'USD';

        // Extract currency code
        if (originalCurrency.toLowerCase().includes('uae') ||
            originalCurrency.toLowerCase().includes('united arab emirates') ||
            originalCurrency.toLowerCase().includes('aed') ||
            originalCurrency.toLowerCase().includes('dirham')) {
            originalCurrency = 'AED';
        } else if (originalCurrency.toLowerCase().includes('usd') ||
            originalCurrency.toLowerCase().includes('dollar') ||
            originalCurrency.toLowerCase().includes('$')) {
            originalCurrency = 'USD';
        } else if (originalCurrency.toLowerCase().includes('sar') ||
            originalCurrency.toLowerCase().includes('riyal') ||
            originalCurrency.toLowerCase().includes('saudi')) {
            originalCurrency = 'SAR';
        } else if (originalCurrency.toLowerCase().includes('qar') ||
            originalCurrency.toLowerCase().includes('qatar')) {
            originalCurrency = 'QAR';
        } else if (originalCurrency.toLowerCase().includes('omr') ||
            originalCurrency.toLowerCase().includes('oman')) {
            originalCurrency = 'OMR';
        } else if (originalCurrency.toLowerCase().includes('bhd') ||
            originalCurrency.toLowerCase().includes('bahrain')) {
            originalCurrency = 'BHD';
        } else if (originalCurrency.toLowerCase().includes('kwd') ||
            originalCurrency.toLowerCase().includes('kuwait')) {
            originalCurrency = 'KWD';
        } else if (originalCurrency.toLowerCase().includes('inr') ||
            originalCurrency.toLowerCase().includes('rupee') ||
            originalCurrency.toLowerCase().includes('₹')) {
            originalCurrency = 'INR';
        } else if (originalCurrency.toLowerCase().includes('eur') ||
            originalCurrency.toLowerCase().includes('euro') ||
            originalCurrency.toLowerCase().includes('€')) {
            originalCurrency = 'EUR';
        } else if (originalCurrency.toLowerCase().includes('gbp') ||
            originalCurrency.toLowerCase().includes('pound') ||
            originalCurrency.toLowerCase().includes('£')) {
            originalCurrency = 'GBP';
        } else {
            // Extract first 3 letters as currency code
            originalCurrency = originalCurrency.substring(0, 3).toUpperCase() || 'USD';
        }

        // Get conversion rate (default to 1 if currency not found)
        const rate = conversionRates[originalCurrency] || 1;

        // Convert to USD
        const minSalaryUSD = Math.round(minSalary * rate);
        const maxSalaryUSD = maxSalary ? Math.round(maxSalary * rate) : null;

        // Format display
        let displayText = '';

        if (maxSalary && maxSalary > minSalary) {
            if (originalCurrency === 'USD') {
                displayText = `USD ${minSalary} - ${maxSalary}/Month`;
            } else {
                displayText = (
                    <>
                        {originalCurrency} {minSalary} - {maxSalary}/Month<br />
                        USD {minSalaryUSD} - {maxSalaryUSD}/Month
                    </>
                );
            }
        } else {
            if (originalCurrency === 'USD') {
                displayText = `USD ${minSalary}/Month${job.negotiable ? ' (Negotiable)' : ''}`;
            } else {
                displayText = (
                    <>
                        {originalCurrency} {minSalary}/Month<br />
                        USD {minSalaryUSD}/Month{job.negotiable ? ' (Negotiable)' : ''}
                    </>
                );
            }
        }

        return displayText;
    };

    // Helper to display house information
    const displayHouseInfo = () => {
        const parts = [];
        if (job.type_of_house) parts.push(job.type_of_house);
        if (job.rooms) parts.push(`${job.rooms} room${job.rooms > 1 ? 's' : ''}`);
        if (job.bathrooms) parts.push(`${job.bathrooms} bathroom${job.bathrooms > 1 ? 's' : ''}`);
        return parts.length > 0 ? parts.join(', ') : 'Not specified';
    };

    if (!job) {
        return (
            <>
                <Navbar />
                <div className="text-center mt-5" style={{ marginTop: '100px' }}>
                    <div className="text-center">Job details not found</div>
                    <button
                        className="btn btn-outline-secondary mt-3"
                        onClick={handleBackToList}
                    >
                        Back to List
                    </button>
                </div>
            </>
        );
    }


    return (
        <>
            <Navbar />
            <section className="agency blog blog-sec blog-sidebar pb-5 blog-list sider" style={{ marginTop: '80px' }}>
                <Container>
                    <Row>
                        <Col md={12} lg={9} className="pe-lg-4">
                            <div className="product-wrapper-grid list-view">
                                <Row>
                                    <Col xs={12} className="col-12_padding_Set">
                                        <div className="agency-box position-relative">
                                            <div className="agency-header-container">
                                                <picture>
                                                    <source media="(max-width:576px)" srcSet="https://cdn.helperplace.com/front-app/assets/images/misc/5-sm.webp" />
                                                    <source media="(max-width:768px)" srcSet="https://cdn.helperplace.com/front-app/assets/images/misc/5-md.webp" />
                                                    <img
                                                        src="https://cdn.helperplace.com/front-app/assets/images/misc/5.jpg"
                                                        alt="Header"
                                                        className="agency_header"
                                                    />
                                                </picture>
                                                <div className="agency_header_White_opcity"></div>

                                                <div className="profile-section">
                                                    <div className="profile-image-wrapper">
                                                        <img
                                                            src={job.profile_photo_url || 'https://cdn-icons-png.flaticon.com/512/1077/1077114.png'}
                                                            alt="Profile"
                                                            className="profile-image"
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.src = 'https://cdn-icons-png.flaticon.com/512/1077/1077114.png';
                                                            }}
                                                        />
                                                    </div>

                                                    <div className="badge-group">
                                                        <label className="label_blue">
                                                            {job.posted_by?.toLowerCase().includes('direct') ? 'Direct' : 'Agency'}
                                                        </label>
                                                        <span className="top-active">Very Active</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="product-box">
                                                <div className="hp-candidate-wrapper">
                                                    <div className="job-title-section">
                                                        <h1 className="mb-0 listing-about-title p-0" style={{ wordBreak: 'break-word' }}>
                                                            {job.job_title || 'No Job Title'}
                                                        </h1>
                                                        <p className="mb-2 p-0 text-left listing-about-sub-title">
                                                            {job.adults || '0'} adults + {job.children || '0'} kids | {job.country || 'N/A'}
                                                            {/* <span> | Posted: {formatDate(job.posted_on)} </span> */}
                                                        </p>
                                                    </div>

                                                    <div className="apply-btn jobdetails-buttons" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                        <Button
                                                            variant="success"
                                                            className="hp-complete-job-btn" style={{ borderRadius: '0px', marginRight: '10px', backgroundColor: '#28a745', borderColor: '#28a745', height: '45px', marginTop: '9px' }}
                                                            onClick={() => navigate('/basicinfo')}
                                                        >
                                                            Complete Job Posting
                                                        </Button>
                                                        <Button
                                                            variant="secondary"
                                                            className="hp-cancel-btn hp-cancel-jobdetails" style={{ borderRadius: '0px', height: '45px' }}
                                                            onClick={handleBackToList}
                                                        >
                                                            Back
                                                        </Button>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                                {/* Job Requirement Section */}
                                {/* Job Requirement Section - Updated to match image */}
                                {/* Job Requirement Section */}
                                <Row className="custom-header-box">
                                    <Col className="mx-auto">
                                        <h2 className="text-light ar">Job Requirement</h2>
                                    </Col>
                                </Row>

                                <Row className="job-requirement">
                                    <Col>
                                        <div className="job-requirement-grid">

                                            <RequirementItem
                                                iconKey="jobRole"
                                                label="Job Role"
                                                value={job.domestic_worker_category || 'N/A'}
                                            />

                                            <RequirementItem
                                                iconKey="jobType"
                                                label="Job Type"
                                                value={job.job_type || 'N/A'}
                                            />

                                            <RequirementItem
                                                iconKey="startDate"
                                                label="Job Start Date"
                                                value={
                                                    job.job_starting_date &&
                                                        ['immediate', 'asap', 'urgent'].some(v =>
                                                            job.job_starting_date.toLowerCase().includes(v)
                                                        )
                                                        ? job.job_starting_date
                                                        : formatDate(job.job_starting_date)
                                                }
                                            />

                                            <RequirementItem
                                                iconKey="location"
                                                label="Location"
                                                value={[
                                                    job.working_city || job.city,
                                                    job.state_or_province,
                                                    job.country
                                                ].filter(Boolean).join(', ') || 'Not specified'}
                                            />

                                            <RequirementItem
                                                iconKey="contract"
                                                label="Contract Status"
                                                value={job.prefer_contract_status || job.contract_status || 'Open / Any'}
                                            />

                                            <RequirementItem
                                                iconKey="accommodation"
                                                label="Accommodation"
                                                value={job.accommodation_type || job.accommodation || job.accommodation_provided || 'Provided'}
                                            />

                                            <RequirementItem
                                                iconKey="dayOff"
                                                label="Weekly Day Off"
                                                value={job.day_off || 'To be discussed'}
                                            />

                                        </div>

                                    </Col>
                                </Row>


                                {/* Job Description Section */}


                                {/* Candidate Requirements Section */}
                                {/* Candidate Requirements Section */}
                                <Row className="custom-header-box">
                                    <Col className="mx-auto">
                                        <h2 className="text-light ar">Candidate Requirements</h2>
                                    </Col>
                                </Row>
                                <Row className="job-requirement">
                                    <Col>
                                        <div className="job-requirement-grid">
                                            <RequirementItem
                                                iconKey="gender"
                                                label="Gender Preference"
                                                value={job.gender || 'Any'}
                                            />
                                            <RequirementItem
                                                iconKey="religion"
                                                label="Religion"
                                                value={job.religion || 'Any'}
                                            />
                                            <RequirementItem
                                                iconKey="education"
                                                label="Education Level"
                                                value={job.education_level || 'Not specified'}
                                            />
                                            <RequirementItem
                                                iconKey="age"
                                                label="Age Preference"
                                                value={job.age || 'Not specified'}
                                            />
                                            <RequirementItem
                                                iconKey="experience"
                                                label="Experience"
                                                value={job.candidate_experience || job.prefer_experience || 'Not specified'}
                                            />
                                            <RequirementItem
                                                iconKey="years-experience"
                                                label="Years of Experience"
                                                value={safeJoin(job.preferred_years_of_experience)}
                                            />
                                            <RequirementItem
                                                iconKey="globe"
                                                label="Preferred Nationalities"
                                                value={safeJoin(job.candidates_country_experience)}
                                            />
                                            <RequirementItem
                                                iconKey="country-experience"
                                                label="Country Experience"
                                                value={safeJoin(job.candidates_country_experience)}
                                            />
                                            <RequirementItem
                                                iconKey="gulf-experience"
                                                label="Gulf Experience"
                                                value={`${job.gulf_experience_years || '0'} years`}
                                            />
                                            <RequirementItem
                                                iconKey="total-experience"
                                                label="Total Experience"
                                                value={`${job.total_experience_years || '0'} years`}
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                {/* Required Skills Section */}
                                <Row className="custom-header-box">
                                    <Col className="mx-auto">
                                        <h2 className="text-light ar">Required Skills / Duties</h2>
                                    </Col>
                                </Row>
                                <Row className="job-requirement">
                                    <Col>
                                        <div className="job-requirement-grid">
                                            {/* Most Important Skill */}
                                            {job.most_important_skill && (
                                                <RequirementItem
                                                    iconKey="star"
                                                    label="Most Important Skill"
                                                    value={job.most_important_skill}
                                                />
                                            )}

                                            {/* Language Skills */}
                                            <RequirementItem
                                                iconKey="language"
                                                label="Language"
                                                value={job.preferred_language_for_worker?.length > 0 ? safeJoin(job.preferred_language_for_worker) : 'Not specified'}
                                            />

                                            {/* Main Skills */}
                                            <RequirementItem
                                                iconKey="main-skills"
                                                label="Main Skills"
                                                value={job.main_skills?.length > 0 ? safeJoin(job.main_skills) : 'Not specified'}
                                            />

                                            {/* Cooking Skills */}
                                            <RequirementItem
                                                iconKey="cooking"
                                                label="Cooking Skills"
                                                value={job.cooking_skills?.length > 0 ? safeJoin(job.cooking_skills) : 'Not specified'}
                                            />

                                            {/* Other Skills */}
                                            <RequirementItem
                                                iconKey="other-skills"
                                                label="Other Skills"
                                                value={job.other_skills?.length > 0 ? safeJoin(job.other_skills) : 'Not specified'}
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                {/* Salary & Benefits Section */}
                                {/* Salary & Benefits Section */}
                                <Row className="custom-header-box">
                                    <Col className="mx-auto">
                                        <h2 className="text-light ar">Salary & Benefits</h2>
                                    </Col>
                                </Row>
                                <Row className="job-requirement">
                                    <Col>
                                        <div className="job-requirement-grid">
                                            <RequirementItem
                                                iconKey="salary"
                                                label="Monthly Salary"
                                                value={displaySalary()}
                                            />
                                            <RequirementItem
                                                iconKey="benefits"
                                                label="Benefits"
                                                value={job.offer_for_selected_candidates?.length > 0 ?
                                                    `${safeJoin(job.offer_for_selected_candidates)} (Provided by sponsor)` :
                                                    'Not specified'
                                                }
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                {/* Family & Accommodation Details */}
                                <Row className="custom-header-box">
                                    <Col className="mx-auto">
                                        <h2 className="text-light ar">Family & Accommodation Details</h2>
                                    </Col>
                                </Row>
                                <Row className="job-requirement">
                                    <Col>
                                        <div className="job-requirement-grid">
                                            <RequirementItem
                                                iconKey="family"
                                                label="Family Size"
                                                value={`${job.adults || '0'} adults, ${job.children || '0'} children`}
                                            />
                                            <RequirementItem
                                                iconKey="house"
                                                label="House"
                                                value={displayHouseInfo()}
                                            />
                                            <RequirementItem
                                                iconKey="pets"
                                                label="Pets"
                                                value={job.have_pets ? 'Yes' : 'No'}
                                            />
                                            <RequirementItem
                                                iconKey="current-helper"
                                                label="Current Helper"
                                                value={job.have_domestic_worker ? 'Yes' : 'No'}
                                            />

                                        </div>
                                    </Col>
                                </Row>

                                {/* Employer Contact Information */}
                                <Row className="custom-header-box">
                                    <Col className="mx-auto">
                                        <h2 className="text-light ar">Employer Contact Information</h2>
                                    </Col>
                                </Row>
                                <Row className="job-requirement">
                                    <Col>
                                        <div className="job-requirement-grid">
                                            <RequirementItem
                                                iconKey="user"
                                                label="Name"
                                                value={job.emp_name || job.name || 'Not specified'}
                                            />
                                            <RequirementItem
                                                iconKey="organization"
                                                label="Organization"
                                                value={job.organization_name || 'Not specified'}
                                            />
                                            <RequirementItem
                                                iconKey="email"
                                                label="Email"
                                                value={job.email_id || 'Not specified'}
                                            />
                                            <RequirementItem
                                                iconKey="phone"
                                                label="Phone"
                                                value={job.phone_number ?
                                                    `${job.phone_number_country_code ? `${job.phone_number_country_code} ` : ''}${job.phone_number}`
                                                    : 'Not specified'
                                                }
                                            />
                                            <RequirementItem
                                                iconKey="whatsapp"
                                                label="WhatsApp"
                                                value={job.whatsapp_number ?
                                                    `${job.whatsapp_number_country_code ? `${job.whatsapp_number_country_code} ` : ''}${job.whatsapp_number}`
                                                    : 'Not specified'
                                                }
                                            />

                                        </div>
                                    </Col>
                                </Row>

                                {/* Job Posting Details */}
                                <Row className="custom-header-box">
                                    <Col className="mx-auto">
                                        <h2 className="text-light ar">Job Posting Details</h2>
                                    </Col>
                                </Row>
                                <Row className="job-requirement">
                                    <Col className="mx-auto">
                                        <Row className="ar">
                                            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                                <h3 className="footer-experience">
                                                    <svg className="icons" height="17" width="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <circle cx="12" cy="12" r="10"></circle>
                                                        <path d="M9 12l2 2 4-4"></path>
                                                    </svg>
                                                    Status: {job.status || 'N/A'}
                                                </h3>
                                            </Col>
                                            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                                <h3 className="footer-experience">
                                                    <svg className="icons" height="17" width="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                                        <circle cx="12" cy="12" r="3"></circle>
                                                    </svg>
                                                    Views: {job.view_count || '0'}
                                                </h3>
                                            </Col>
                                            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                                <h3 className="footer-experience">
                                                    <svg className="icons" height="17" width="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                                        <line x1="16" y1="2" x2="16" y2="6"></line>
                                                        <line x1="8" y1="2" x2="8" y2="6"></line>
                                                        <line x1="3" y1="10" x2="21" y2="10"></line>
                                                    </svg>
                                                    Posted: {formatDateTime(job.posted_on)}
                                                </h3>
                                            </Col>
                                            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                                <h3 className="footer-experience">
                                                    <svg className="icons" height="17" width="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <circle cx="12" cy="12" r="10"></circle>
                                                        <polyline points="12 6 12 12 16 14"></polyline>
                                                    </svg>
                                                    {/* Profile Completion: {job.columns_percentage || '0'}% */}
                                                </h3>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>


                                <Row className="custom-header-box">
                                    <Col className="mx-auto">
                                        <h2 className="text-light ar">Job Description</h2>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="mx-auto mb-3 jOb_description description_tag ar">
                                        <div style={{ wordBreak: 'break-word', textAlign: 'justify' }}>
                                            {stripHTML(job.job_description)}
                                        </div>
                                    </Col>
                                </Row>

                                <span className="float-right float-left-ar primary pointer mr-2 ml-2" style={{ textAlign: "end" }}> Report this Job </span>
                            </div>
                        </Col>

                        {/* Sidebar with Related Jobs */}
                        <Col md={12} lg={3} className="collection-filter-block resume-right-block">
                            <div className="sticky-top" style={{ top: '90px' }}>
                                <h4 className="mb-4 employer-similarjobs-heading">Similar Jobs</h4>
                                {relatedJobs.length > 0 ? (
                                    relatedJobs.map((relatedJob) => (
                                        <div key={relatedJob.id} className="mb-4 employer-similarjobs-card">
                                            <div className="blog-agency-employer">
                                                <div className="blog-contain">
                                                    <div className="img-container">
                                                        <div
                                                            className="blog-info-resume"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => navigate(`/jobdetails`, { state: { job: relatedJob } })}
                                                        >
                                                            <picture>
                                                                <source srcSet="https://cdn.helperplace.com/misc/jpi/3/Dad%202%20kids-sm.webp" />
                                                                <img
                                                                    width="70px"
                                                                    height="70px"
                                                                    className="related-profile-picture-employer"
                                                                    src={relatedJob.employer_profile_pic || "https://cdn.helperplace.com/misc/jpi/default_family.jpg"}
                                                                    alt={relatedJob.job_title}
                                                                />
                                                            </picture>
                                                            <div className="ar">
                                                                <h4 className="blog-head fixed-1-line">{relatedJob.job_title || 'No Title'}</h4>
                                                                <p className="card-text">
                                                                    <span className="related-employer-type">Family</span> - {relatedJob.nationality || 'N/A'}
                                                                </p>
                                                                <p className="card-text" style={{ marginLeft: '-22px' }}>
                                                                    <svg className="icons" height="17" width="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                                                        <circle cx="12" cy="10" r="3"></circle>
                                                                    </svg>
                                                                    {relatedJob.working_city || 'N/A'}, {relatedJob.state_or_province || 'N/A'}
                                                                </p>
                                                                <p className="card-text" style={{ marginLeft: '-22px' }}>
                                                                    <svg className="icons" height="17" width="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                        <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                                                                        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                                                                    </svg>
                                                                    {relatedJob.domestic_worker_category || 'N/A'} | {relatedJob.job_type || 'N/A'}
                                                                </p>
                                                                <p className="card-text" style={{ marginLeft: '-22px' }}>
                                                                    <svg className="icons" height="17" width="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                                                        <line x1="16" y1="2" x2="16" y2="6"></line>
                                                                        <line x1="8" y1="2" x2="8" y2="6"></line>
                                                                        <line x1="3" y1="10" x2="21" y2="10"></line>
                                                                    </svg>
                                                                    From {formatDate(relatedJob.job_starting_date)}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p>No similar jobs found</p>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Registration Popup */}
            {showRegisterPopup && (
                <div className="modal-backdrop" style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    zIndex: 1050,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <div className="modal-content" style={{
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '0px',
                        maxWidth: '500px',
                        width: '90%',
                        maxHeight: '90vh',
                        overflowY: 'auto'
                    }}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>Register to Apply</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={closeRegisterPopup}
                                aria-label="Close"
                            ></button>
                        </div>
                        {/* <Register onSuccess={closeRegisterPopup} /> */}
                    </div>
                </div>
            )}

            {/* Login Popup */}
            {showLoginPopup && (
                <div className="modal-backdrop" style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    zIndex: 1050,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                    <div className="modal-content" style={{
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '0px',
                        maxWidth: '500px',
                        width: '90%',
                        maxHeight: '90vh',
                        overflowY: 'auto'
                    }}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>Login to Apply</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={closeLoginPopup}
                                aria-label="Close"
                            ></button>
                        </div>
                        {/* <Login onSuccess={handleLoginSuccess} /> */}
                    </div>
                </div>
            )}
            <Footer />
        </>
    );
}

export default JobDetails;
